/*
 * @Author: chengyu
 * @Date: 2022-09-22 10:52:22
 * @Description: 初始化配置信息
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSilentError } from '../utils/error';
var projectName = 'MapApi';
var ampLogKey = 'map_api_fail';
var Config;
/**
 * 检查必填参数
 * @param options
 */
function checkOptions(options) {
    var required = [
        'env',
        'contextEnv',
        'context',
        'UBT',
        'APM',
        'extraInfo',
        'gaode',
        'lbs',
    ];
    required.forEach(function (key) {
        var value = options[key];
        var noExist = !(key in options) || !value;
        if (noExist) {
            throw createSilentError({
                message: "[".concat(projectName, "] initConfig (").concat(key, ") \u53C2\u6570\u662F\u5FC5\u4F20\u53C2\u6570, \u53C2\u8003\uFF1Ahttps://hellobike.yuque.com/docs/share/2317035d-ed4d-442e-9fa8-3a14d0628a3c"),
            });
        }
    });
}
function initConfig(options) {
    checkOptions(options);
    Config = __assign({}, options);
}
function getConfig() {
    return Config;
}
/**
 * 调试模式
 */
function getDebug() {
    return Config.debug || false;
}
/**
 * 运行环境
 *
 * -- 例如：运行在支付宝小程序中 --
 * ```ts
 * const context = getContext();
 *
 * context.request(); // context = my;
 * ```
 */
function getContext() {
    return Config.context;
}
/**
 * 环境变量
 */
function getEnv() {
    return Config.env;
}
/**
 * 当前运行环境
 */
function getContextEnv() {
    return Config.contextEnv;
}
/**
 * 天启
 */
function getUBT() {
    return Config.UBT;
}
/**
 * 性能埋点
 */
function getAPM() {
    return Config.APM;
}
/**
 * 从配置中获取额外的版本信息等...
 */
function getExtraInfo() {
    return Config.extraInfo || {};
}
/**
 * 高德配置信息
 */
function getGaoConfig() {
    return Config.gaode;
}
/**
 * LBS配置信息
 */
function getLbsConfig() {
    return Config.lbs;
}
/**
 * 默认参数
 */
function getDefaultOptions() {
    return {
        key: Config.gaode.key,
        appKey: Config.lbs.appKey,
        secretKey: Config.lbs.secretKey,
    };
}
/**
 * 设置环境变量
 */
function setEnv(env) {
    if (Config)
        Config.env = env;
    return env;
}
/**
 * 判断是否初始化过了
 */
function isInit() {
    return !!Config;
}
export { ampLogKey, isInit, initConfig, getConfig, getDebug, getContext, getEnv, setEnv, getContextEnv, getUBT, getAPM, getExtraInfo, getGaoConfig, getLbsConfig, getDefaultOptions, };
//# sourceMappingURL=data:application/json;base64,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